//@flow
import { isValidDate } from '../../Utils/dateUtil';
import {YES,NO} from '../../Utils/variables'
import type { InvoiceHeaderContainer$Props } from './flowTypes'
import type { Collection } from 'collect.js'

export const validate = (values:any,props:InvoiceHeaderContainer$Props) => {
    const { deimos } = props;
    const errors = {};
    let requiredFields = [
        'vendorName',
        'invNo',
        'invDate',
        'total'
      ];
    
    if (!values.isInvalidDoc){
        requiredFields.forEach(field => {
            if (!values[field]) {
                errors[field] = 'Required'
            }
        })
    }  
    //Validate Invoice Date
    if (values.invDate && !isValidDate(values.invDate)){
        errors.invDate = 'Invalid date format for this pattern mm/dd/yyyy'
    }
    
    validateQualityReviewQuestions(values,errors,props)

    const updateFormError = (props.updateFormError:any)
    updateFormError(errors);

    return errors;
}

const validateQualityReviewQuestions=(values:any,errors:any,props:InvoiceHeaderContainer$Props)=>{
    const deimos = (props.deimos:any)
    const reviewQuestions = (deimos.reviewQuestions:any)

    const questions = reviewQuestions.filter(question=> question.mandatory == true)
    questions.map(question=>{
        if (question.questionType == 'singleSelect'){
            if (!values[question.elementId]){
                errors[question.elementId] = 'This field is required!'
            }
        }else if (question.questionType == 'yesNo'){
            const yesElement = `${question.elementId}_${YES}`
            const noElement = `${question.elementId}_${NO}`

            if (!values[yesElement] && !values[noElement]){
                errors[yesElement] = 'Please select at least one answer.'
                errors[noElement] = 'Please select at least one answer.'
            }else {
                if (values[yesElement]){
                    let anySubAnswers = []
                    question.yesSubAnswers.map(subAnswer=>{
                        if (values[subAnswer.field]){
                            anySubAnswers.push(subAnswer)
                        }
                    })
                    if (anySubAnswers.length == 0){
                        question.yesSubAnswers.map(subAnswer=>{
                            if (!values[subAnswer.field]){
                                errors[subAnswer.field] = 'Please select at least one answer.'
                            }
                        })
                    }
                }
            }
        }
    })
}

export const getQualityReviewFormNoOfError=(props:InvoiceHeaderContainer$Props,collectErrorFields:Collection<any>)=>{
    let noOfError = 0
    const deimos = (props.deimos:any)
    const reviewQuestions = (deimos.reviewQuestions:any)

    const questions = reviewQuestions.filter(question=> question.mandatory == true)
    questions.map(question=>{
        if (question.questionType == 'singleSelect'){
            if (collectErrorFields.has(question.elementId)){
                noOfError+=1
            }
        }else if (question.questionType == 'yesNo'){
            const yesElement = `${question.elementId}_${YES}`
            const noElement = `${question.elementId}_${NO}`

            if (collectErrorFields.has(yesElement) && collectErrorFields.has(noElement)){
                noOfError+=1
            }else {
                let anySubAnswersError = false
                question.yesSubAnswers.map(subAnswer=>{
                    if (collectErrorFields.has(subAnswer.field)){
                        anySubAnswersError = true
                    }
                })
                if (anySubAnswersError){
                    noOfError+=1
                }    
            }
        }
    })

    return noOfError
}


// WEBPACK FOOTER //
// ./src/views/ProjectDeimos/validate.js